import type { Content } from '@plone/types';
import isEqual from 'lodash/isEqual';
import { useMemo } from 'react';

function useSlotContentIsLoaded<T extends Content = Content>(content: T) {
  const contentLoaded = useMemo(
    () => content && !isEqual(Object.keys(content), ['lock']),
    [content],
  );
  return contentLoaded;
}

export { useSlotContentIsLoaded };
